/* eslint-disable no-console */
/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
import { formPlaApiPricingPayload } from '../../../utils/plaConfigurationUtils';
import { UPDATE_PLA_CONFIGURED_PRICE, setUpdatedPlaConfiguredPrice } from '../../../actions/plaConfigurations';
import { getNewPlaConfiguredPrice } from '../../../api/plaConfigurationApi';

export const configurationIdForSelectionsMiddleware = (state) => (next) => (action) => {
  const { dispatch, getState } = state;
  next(action);
  switch (action?.type) {

  case UPDATE_PLA_CONFIGURED_PRICE:

    const { choices } = getState()?.plaConfiguration.plaConfigurationDetails.configuration;
    const { storeNumber } = getState()?.store;
    const { allSurfaceColors, selectedThickness, availableSkus } = getState()?.countertops;
    const { color } = action.payload;
    const selectedSku = allSurfaceColors.find((surfaceColor) => surfaceColor.optionId === color.externalId && surfaceColor.height === selectedThickness)?.sku;
    const { siteId, productId, productLineId } = typeof window !== 'undefined' ? window.injectedConfiguratorSettings : {};

    const selections = formPlaApiPricingPayload(choices, color);

    const apiPayload = {
      siteId, productId, choices: selections, storeId: storeNumber, productLineId, availableSkus, selectedSku
    };

    getNewPlaConfiguredPrice(apiPayload).then((priceDetails) => {
      dispatch(setUpdatedPlaConfiguredPrice(priceDetails));
    });

    break;

  default:
    break;
  }
};

export default configurationIdForSelectionsMiddleware;
